<li data-id="{{item.id}}" data-index="{{index}}" class="list-item btn {{stateClass}}">
    <div>
        <h3>{{item.name}}</h3>
    </div>
</li>